import { Page } from '@hotjar/webapp/components/Page';
import { PageHeader, tokens } from '@hotjar/hotsauce';
import { ResponseLimitAlert, ResponsesCollectedAlert } from '@hotjar/feedback';
import type { Survey } from '@hotjar/feedback';
import styled from '@emotion/styled';

export type SurveyWizardMode = 'create' | 'edit';

export interface SurveyWizardHeaderProps {
  mode: SurveyWizardMode;
  name: Survey['name'];
  surveyId?: Survey['id'];
  responseCount?: Survey['response_count'];
}

const MinHeightContainer = styled.div`
  min-height: ${tokens.spacer.x7};
  margin-bottom: ${tokens.spacer.x2};
`;

export function SurveyWizardHeader({
  name,
  mode,
  surveyId,
  responseCount,
}: SurveyWizardHeaderProps): JSX.Element {
  const titlesMap: Record<SurveyWizardMode, string> = {
    create: 'Create a new survey',
    edit: name,
  };

  return (
    <>
      <Page>
        <MinHeightContainer>
          <PageHeader title={titlesMap[mode]} />
        </MinHeightContainer>
      </Page>
      <ResponseLimitAlert location="survey-wizard" featureGroup="surveys" />
      <ResponsesCollectedAlert
        widgetType="survey"
        mode={mode}
        surveyId={surveyId}
        responseCount={responseCount}
      />
    </>
  );
}
